import { CtaShell } from "./cta-shell"
import type { CtaShellProps } from "./cta-types"

export type FinalCtaProps = Omit<CtaShellProps, "headline"> & {
	headline?: string
	title?: string
	description?: string
	supportingPoints?: string[]
}

export function FinalCta(props: FinalCtaProps) {
	return (
		<CtaShell
			{...props}
			headline={props.headline ?? props.title ?? "Start building with confidence."}
			supportingLine={props.supportingLine ?? props.description}
			trustMicrocopy={props.trustMicrocopy ?? props.supportingPoints?.slice(0, 2).join(". ")}
			placement="final"
			layout={props.layout ?? "split"}
			background={props.background ?? { type: "brand" }}
		/>
	)
}
